import moment from 'moment'
import { Nullable } from '@/shared/types/app.types'

export class DateUtils {
    static get datePattern(): string {
        return 'YYYY-MM-DD'
    }
    static get dateTimePattern(): string {
        return 'YYYY-MM-DD HH:mm'
    }
    static get dateTimeWithSecondsPattern(): string {
        return 'YYYY-MM-DD HH:mm:ss'
    }
    static get zonedDateTimePattern(): string {
        return 'YYYY-MM-DDTHH:mm:ss.SSSSSSZ'
    }

    static get localeDatePattern(): string {
        return moment.localeData().longDateFormat('L')
    }

    static get localeDatePatternWithText(): string {
        return moment.localeData().longDateFormat('LL')
    }

    static get localeDateTimePattern(): string {
        return moment.localeData().longDateFormat('llll')
    }

    static formatDate(date: Nullable<Date>, format: string = DateUtils.datePattern): string | null {
        return date ? moment(date).format(format) : null
    }
}
